<template>
  <div class="cargo-loading container-fluid pl-0 pr-0">
    <div class="info-bar-back">
      <template v-if="cargoDetails">
          <div :class="cargoDetails.palletPlaces ? 'cargo-name' : 'cargo-name-span'" style="font-size:15px;">{{ cargoDetails.reference }}</div>
          <div class="pallet-places" v-if="cargoDetails.palletPlaces"
               style="font-weight:500;font-size:13px;">
            {{ cargoDetails.palletPlaces.toFixed(1) }}
          </div>
      </template>
      <div id="expandButton">
        <a @click="toggleExpand()" v-if="getExpandAll">
          <i class="fas fa-minus-square"/>
        </a>
        <a @click="toggleExpand()" v-else>
          <i class="fas fa-plus-square"/>
        </a>
      </div>
      <a :to="{name:'loading'}" @click="$router.go(-1)" class="back-button  float-right">{{ $t('button.back') }}</a>
    </div>
    <div class="info-bar-back info-bar-back-no-top-padding" v-if="cargoDetails  && (getMeBasic.companyId === 7 || getMeBasic.companyId === 1)">
      <button
              v-if=" !cargoDetails.finished"
              @click="finishCargo(cargoDetails)" class="btn btn-success btn-block cargo-finished-button">
        {{ $t('shopfloor.unloadingPage.finishCargo') }}
      </button>
      <div v-else class="cargo-finished">
        {{ $t('shopfloor.unloadingPage.cargoFinished') }}<i class="cargo-finished-checkmark fas fa-check"></i>
      </div>
    </div>
    <div class="scrollable-cargo-order-container">
      <cargoOrder
          :key="idx"
          v-for="(order,idx) in getOrdersFromCargo($route.params.id)"
          @clicked="setInlineDetails($event) "
          :idx="idx"
          :id="'cargo-'+idx"
          class="loading-cargo-info"
          :inlineDetails="inlineDetails"
          :order="order"
      />
    </div>

    <div
        v-if="isMobile()"
        class="barcode-input-wrap"
        :class="{ 'show-manual-barcode': showManualBarcode }"
    >
      <div @click="toggleManualBarcode()" class="w-100">
        <label>{{ $t('shopfloor.unloadingPage.manualBarcode') }}</label>
        <i class="fas toggle-barcode" :class="toggleManualBarcodeClass"/>
      </div>
      <form @submit.prevent="barcodeScanned(manualBarcode)" v-if="showManualBarcode" class="d-flex">
        <input type="text" class="form-control" v-model="manualBarcode"/>
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-chevron-right"/>
        </button>
      </form>
    </div>

    <div v-if="!getOrdersFromCargo($route.params.id).length">
      <p class="no-orders">{{ $t('shopfloor.loadingPage.orders.noOrders') }}</p>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import cargoOrder from '../../components/loading/CargoOrder';
import isMobile from '../../plugins/isMobile';


export default {
  props: ['id'],
  name: 'cargo-orders',
  components: {
    cargoOrder
  },
  data() {
    return {
      cargoDetails: null,
      inlineDetails: null,
      previousBarcode: null,
      beingProcessed: false,
      showManualBarcode: false,
      scannedLocation: null,
      barcodeToScan: null,
      scannedProductToLoad: null
    };
  },
  computed: {
    ...mapGetters('orders', [
      'getOrders',
      'getOrder',
      'getOrdersFromCargo',
      'getCurrentOrderPicking',
      'getCurrentProductPicking',
      'getOrderIdsFromCargo'

    ]),
    ...mapGetters('cargo', ['getCargo']),
    ...mapGetters('locations', ['getLocation']),
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('users', ['getMeBasic']),
    ...mapGetters('pickLocations', ['getPicklocations', 'getPickLocationsOfCargo']),
    ...mapGetters('root', ['getExpandAll']),

    toggleManualBarcodeClass() {
      return this.showManualBarcode ? 'fa-chevron-down' : 'fa-chevron-up';
    }
  },
  methods: {
    ...mapMutations('orders', ['setCurrentProductPicking']),
    ...mapActions('cargo', ['finishCargoByDockId']),
    // ...mapActions('orders', ['setCurrentOsrderPicking']),
    ...mapActions('orderProducts', [
      'checkIfProductIsKnownInOrder',
      'incrementAmountPicked',
      'checkAmountPicked',
      'fullProductInfo'
    ]),
    ...mapActions('loading', ['updateScannedProduct']),
    ...mapActions('root', ['setExpandAll']),
    setInlineDetails(event) {
      if (event === this.inlineDetails) {
        this.inlineDetails = null;
      } else {
        this.inlineDetails = event;
      }
    },
    isMobile() {
      return isMobile.check();
    },
    async finishCargo(cargo) {
      let html = `<div>${this.$root.$t('shopfloor.unloadingPage.model.finishCargo.textNormal')}</div>`;
      if (cargo.status !== 'done') {
        html += `<div style="margin-top: 1rem; color: red; font-weight: bold;">${this.$root.$t('shopfloor.unloadingPage.model.finishCargo.textNotFinished')}</div>`
      }
      const result  = await this.$swal({
        title: this.$root.$t('shopfloor.unloadingPage.model.finishCargo.title'),
        html,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText:  this.$root.$t('shopfloor.unloadingPage.model.finishCargo.confirmButtonText'),
        cancelButtonText: this.$root.$t('shopfloor.unloadingPage.model.finishCargo.cancelButtonText'),
        reverseButtons: true
      });
      if (result.value) {
        await this.finishCargoByDockId({id: cargo.id, finishedBy: this.getMeBasic});
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 500000,
          type: 'success',
          title: this.$t('shopfloor.unloadingPage.cargoFinishedSuccessfully')
        });
      }
    },
    scrollProductIntoView(id) {
      let elementToScrollTo = document.getElementById('product-barcode-' + id);
      if (elementToScrollTo) {
        elementToScrollTo.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
        window.scrollBy(0, 60);
      }
    },
    warningModal(warningText) {
      this.$swal
          .fire({
            customClass: 'm-swal-load-unload',
            width: '80%',
            title: this.$root.$t('shopfloor.modalWarning.title'),
            html: warningText
          })
          .then(() => {
            this.scannedLocation = null;
            this.setCurrentProductPicking(null);
          });
    },
    wrongTrailerModal() {
      return this.$swal
          .fire({
            customClass: 'm-swal-load-unload',
            width: '80%',
            showConfirmButton: false,
            showCancelButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            title: this.$root.$t('shopfloor.loadingPage.wrongTrailerTitle'),
            cancelButtonText: this.$root.$t('shopfloor.modalWarning.cancel'),
            html: this.$root.$t('shopfloor.loadingPage.wrongTrailer', {
              cargoNumber: this.barcodeToScan,
              productNumber: this.scannedProductToLoad.productNumber
            })
          })
          .then(res => {
            if (res.dismiss == 'cancel') {
              this.resetValues();
            }
          });
    },
    showUnknownBarcodePopUp() {
      return this.$swal({
        title: this.$root.$t('shopfloor.stockChanges.unknownBarcode.title'),
        text: this.$root.$t('shopfloor.stockChanges.unknownBarcode.message'),
        type: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$root.$t('shopfloor.stockChanges.unknownBarcode.button'),
      });
    },
    async barcodeScanned(barcode) {

      barcode = barcode.replace(/(\r\n|\n|\r)/gm, "").trim()

      if (this.getCurrentProductPicking && !this.$APP_CONFIG.loading.checkTransport) {
        return;
      }
      if (this.$APP_CONFIG.loading.scanLocationFirst && !this.scannedLocation) {
        // check if scanned code is a location
        let location =   this.getLocation(barcode);
        if(!location.name){
           await this.$store.dispatch('locations/fetchById',barcode.toString())
          // location = await this.$FB.collection('locations').doc(barcode.toString()).get()
          location = this.getLocation(barcode)
          // let location =   this.getLocation(barcode);
          // if(location.data()){
          //   location = location.data()
          // }
        }
        let availableLocations = this.getPickLocationsOfCargo(this.$route.params.id);

        if (location) {
          availableLocations = _.filter(availableLocations, loc => loc.name === location.name);
          let isPickLocation = _.find(availableLocations, loc => {
            return loc.name === location.name;
          }) !== undefined ? _.find(availableLocations, loc => {
            return loc.name === location.name;
          }) : false;
          if (!isPickLocation) {
            return this.$swal(this.$root.$t('shopfloor.loadingPage.unknownLocationInCargo')).then(() => {
              this.resetValues();
            });
          }
          let allpicked = _.every(availableLocations, pickLoc => {
            return pickLoc.amount === pickLoc.amountPicked && location.name === pickLoc.name;
          });
          if (allpicked) {
            return this.$swal({
              text: 'Alles is al geladen van locatie: ' + location.name,
            }).then(() => {
              this.resetValues()
              this.setCurrentProductPicking(null)
            })
          }
          this.scannedLocation = location;
          return this.methodsShowScanProductSwal()
        } else {
          return this.checkIfProductIsKnownInOrder({
            barcode,
            cargoId: this.$route.params.id
          }).then(orderProduct => {

            if (orderProduct) {
              this.fullProductInfo(orderProduct).then(fullProductInfo => {
                if (!fullProductInfo.barcodeUnreadable)
                  return this.$swal({text: this.$root.$t('shopfloor.loadingPage.isNotALocation')}).then(() => {
                    this.resetValues();
                  });
              });
            } else {
              return this.$swal({text: this.$root.$t('shopfloor.loadingPage.isNotALocation')}).then(() => {
                this.resetValues();
              });
            }
          });

        }
      } else if (this.$APP_CONFIG.loading.scanLocationFirst && this.scannedLocation && this.getMeBasic.companyId === 9) {
        if (!barcode.match(/^\d*\s\d*$/)) {
          await this.showUnknownBarcodePopUp();
          return this.methodsShowScanProductSwal();
        }
      }
      if (this.$APP_CONFIG.loading.checkTransport && this.barcodeToScan && this.getCurrentProductPicking) {
        // This should now check if scanned code is equal to barcode toscan
        // if this is true then product is loaded

        if (barcode.toLowerCase() == this.barcodeToScan.toLowerCase()) {

          return this.incrementAmountPicked(this.scannedProductToLoad)
              .then(response => {
                this.showManualBarcode = false;
                this.manualBarcode = '';
                if (response.error === 'max_amount_picked') {
                  this.setCurrentProductPicking(null);
                  this.barcodeToScan = null;
                  return this.warningModal(
                      this.$root.$t('shopfloor.modalAmountAlreadyPicked.html', {
                        product_number: this.scannedProductToLoad.product_number,
                        orderId: this.scannedProductToLoad.orderId
                      })
                  );
                }
              })
              .then(() => {
                this.setCurrentProductPicking(null);
                this.barcodeToScan = null;
                this.productLoaded(this.scannedProductToLoad.productNumber);
                this.scannedProductToLoad = null;
                return;
              });
        } else {
          return this.wrongTrailerModal();
        }
      }

      return this.checkIfProductIsKnownInOrder({
        barcode,
        cargoId: this.$route.params.id
      }).then(orderProduct => {
        if (!orderProduct) {
          return this.warningModal(this.$root.$t('shopfloor.loadingPage.unknownProductInCargo', [barcode]));
        }

        if (orderProduct.fullyPicked) {
          return this.warningModal(
              this.$root.$t('shopfloor.modalAmountAlreadyPicked.html', {
                name: orderProduct.productName,
                product_number: orderProduct.productNumber,
                orderId: orderProduct.orderId
              })
          );
        }

        this.fullProductInfo(orderProduct).then(fullProductInfo => {
          fullProductInfo.locations = _.filter(fullProductInfo.locations, loc => barcode === loc.productNumber)

          if (!fullProductInfo.locations.length) {
            this.warningModal(this.$root.$t('shopfloor.modalUnknownLocation.text'));
          } else {
            if (this.$APP_CONFIG.loading.scanLocationFirst && this.scannedLocation) {
              let locationName = this.scannedLocation.name;
              let isCorrectLocation = false;
              _.each(fullProductInfo.locations, loc => {
                if (loc.name === locationName) {
                  isCorrectLocation = true;
                }
              });
              if (!isCorrectLocation) {
                this.$swal({
                  text: this.$root.$t('shopfloor.loadingPage.locationUnknownForProduct')
                });
                return this.resetValues();
              }
            }
            let allLocationsPicked = _.every(fullProductInfo.locations, loc => {
              return loc.amountPickable == loc.amountPicked;
            });
            if (allLocationsPicked) {
              return this.warningModal(
                  this.$root.$t('shopfloor.modalAmountAlreadyPicked.html', {
                    name: fullProductInfo.productName,
                    product_number: fullProductInfo.productNumber,
                    orderId: fullProductInfo.orderId
                  })
              );
            }
            this.scrollProductIntoView(orderProduct.id);
            this.setCurrentProductPicking({
              startTime: new Date(),
              barcode: barcode,
              product: orderProduct,
              cargoId: this.$route.params.id,
              userId: this.getMeBasic.userId,
              userName: this.getMeBasic.userName,
              companyId: this.getMeBasic.companyId
            });
            // eslint-disable-next-line no-undef
            this.inlineDetails = _.findIndex(this.getOrdersFromCargo(this.$route.params.id), {id: orderProduct.orderId.toString()});
            if (this.$APP_CONFIG.loading.checkTransport) {
              // this.checkIfTransportNeedsToBeSkipped(orderProduct.cargoId).then(
              //     skip => {
              //       if (skip) {
              //         this.manualLoad(barcode, orderProduct, fullProductInfo);
              //       } else {
              this.checkIfProductMeantForTransport(
                  barcode,
                  orderProduct,
                  fullProductInfo
              );
              //       }
              //     }
              // );
            } else {
              this.manualLoad(barcode, orderProduct, fullProductInfo);
            }
          }
        });
      });
    },
    methodsShowScanProductSwal() {
      return this.$swal({
        title: location.name,
        text: this.$root.$t('shopfloor.loadingPage.locationKnown', [location.name]),
        allowEscapeKey: false,
        allowOutsideClick: true,
        showCancelButton: false,
        showConfirmButton: false
      }).then(res => {
        if (res.dismiss == 'cancel' || res.dismiss == 'backdrop') {
          this.resetValues();
        }
      });
    },
    showSkipSwal() {
      return this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        title: 'Voertuig scannen overslaan',
        html:
            'Wilt u het scannen van het voertuig overslaan en deze direct laden?',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        showConfirmButton: true
      });
    },
    checkIfTransportNeedsToBeSkipped(cargoId) {
      return new Promise(skip => {
        const cargo = this.getCargo(cargoId);
        if (cargo.trailerNumber) {
          if (
              cargo.trailerNumber.match(
                  /^[a-zA-Z0-9]|^.[a-zA-Z0-9]|^..[a-zA-Z0-9]/
              )
          ) {
            this.showSkipSwal().then(response => {
              if (response.value) {
                skip(true);
              } else {
                skip(false);
              }
            });
          } else {
            return skip(false);
          }
        } else if (cargo.truckNumber) {
          if (
              cargo.truckNumber.match(/^[a-zA-Z0-9]|^.[a-zA-Z0-9]|^..[a-zA-Z0-9]/)
          ) {
            this.showSkipSwal().then(response => {
              if (response.value) {
                skip(true);
              } else {
                skip(false);
              }
            });
          } else {
            return skip(false);
          }
        } else {
          skip(false);
        }
      });
    },
    toggleManualBarcode() {
      this.showManualBarcode = !this.showManualBarcode;
    },
    toggleExpand() {
      this.setExpandAll(!this.getExpandAll);
    },
    checkIfProductMeantForTransport(barcode, orderProduct, fullProductInfo) {
      const cargoId = orderProduct.cargoId;
      const cargo = this.getCargo(cargoId);
      this.barcodeToScan = cargo.trailerNumber
          ? cargo.trailerNumber
          : cargo.truckNumber;
      this.scannedProductToLoad = fullProductInfo;
      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        title: this.$t('shopfloor.loadingPage.scanCargoTitle'),
        html: this.$t('shopfloor.loadingPage.scanCargo', {
          productNumber: barcode,
          cargoNumber: this.barcodeToScan
        }),
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        showConfirmButton: false
      }).then(res => {
        if (res.dismiss == 'cancel') {
          this.resetValues();
        }
      });
    },
    manualLoad(barcode, orderProduct, fullProductInfo) {

      this.$swal
          .fire({
            customClass: 'm-swal-load-unload',
            width: '80%',
            allowEscapeKey: false,
            allowOutsideClick: false,
            stopKeydownPropagation: false,
            showCancelButton: true,
            title: this.$root.$t('shopfloor.modalProductScanned.title'),
            html: orderProduct
                ? this.$root.$t(
                    'shopfloor.modalProductScanned.loadingProductHtml',
                    {...orderProduct}
                )
                : this.$root.$t('shopfloor.modalProductScanned.html', [barcode]),
            showConfirmButton: true,
            confirmButtonClass: this.getMeBasic.companyId === 9 ? 'tvat-confirm-button' : '',
            confirmButtonText: this.$root.$t(
                'shopfloor.modalProductScanned.submit'
            ),
            cancelButtonClass: this.getMeBasic.companyId === 9 ? 'tvat-cancel-button' : '',
            cancelButtonText: this.$root.$t('shopfloor.modalWarning.cancel')
          })
          .then(result => {
            if (result.value) {
              fullProductInfo.scannedLocation = _.cloneDeep(this.scannedLocation);
              this.incrementAmountPicked(fullProductInfo).then(response => {
                this.showManualBarcode = false;
                this.manualBarcode = '';
                if (response.error === 'max_amount_picked') {
                  return this.warningModal(
                      this.$root.$t('shopfloor.modalAmountAlreadyPicked.html', {
                        product_number: orderProduct.product_number,
                        orderId: orderProduct.orderId
                      })
                  );
                } else {
                  this.productLoaded(orderProduct.productNumber);
                }
              });
            } else {
              this.setCurrentProductPicking(null);
              this.resetValues();
            }
          });
    },
    productLoaded(productNumber) {
      this.scannedLocation = null;
      return this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$root.$t('shopfloor.loadingPage.loaded', [productNumber])
      });
    },
    resetValues() {
      this.setCurrentProductPicking(null);
      this.barcodeToScan = null;
      this.scannedLocation = null;
      this.scannedProductToLoad = null;
    }
  },
  watch: {
    inlineDetails(newV, oldV) {
      // eslint-disable-next-line no-undef
      if (this.inlineDetails && !_.isEqual(newV, oldV)) {
        let elementToScrollTo = document.getElementById(
            'cargo-' + this.inlineDetails
        );
        elementToScrollTo.scrollIntoView({behavior: 'smooth'});
      }
    }
  },
  async beforeRouteLeave(from, to, next) {
    await this.$store.dispatch('resetStoreModules', [
      'pickLocations',
      'orders',
      'orderProducts'
    ]);
    await this.$barcodeScanner.barCodeEventBus.$off(
        'barcodeScanned',
        this.barcodeScanned
    );
    next();
  },
  created() {
    let paramsId = this.$route.params.id;
    this.$store.dispatch('cargo/fetchById', paramsId).then(cargo => {
      this.cargoDetails = cargo;
      if (
          (cargo.status !== 'done' && cargo.status !== 'loading') ||
          (!cargo.startTime && cargo.status !== 'done')
      ) {
        this.$store.dispatch('cargo/patch', {
          id: paramsId,
          status: 'loading',
          startTime: new Date()
        });
      }
    });
    this.$barcodeScanner.barCodeEventBus.$on(
        'barcodeScanned',
        this.barcodeScanned
    );

    this.$store
        .dispatch('initDataForPage', [
          {
            module: 'pickLocations',
            where: ['cargoId', '==', parseInt(paramsId)]
          },
          {module: 'orders', where: ['cargoId', '==', parseInt(paramsId)]},
          // 'orderProducts',
          {
            module: 'orderProducts',
            where: ['cargoId', '==', parseInt(paramsId)]
          }
        ])
        .then(() => {
          if (this.$route.query.orderId) {
            // eslint-disable-next-line no-undef
            this.inlineDetails = _.findIndex(
                this.getOrdersFromCargo(this.$route.params.id),
                {id: this.$route.query.orderId}
            );
          }
        });
  }
};
</script>


<style lang="scss">
.barcode-input-wrap {
  position: fixed;
  z-index: 11;
  width: calc(100% - 250px);
  bottom: 0;
  padding: 10px 15px 0;
  background: #f5f5f5;
  border-top: 1px solid #dcdcdc;

  &:hover {
    cursor: pointer;
  }

  .toggle-barcode {
    right: 15px;
    position: absolute;
    line-height: 42px;
    top: 0;
  }

  label {
    text-transform: uppercase;
    white-space: nowrap;
    margin: 0 0 10px;
  }
}

.unloading-info:last-child {
  margin-bottom: 42px;
}

.show-manual-barcode {
  padding-bottom: 15px;

  .unloading-info:last-child {
    margin-bottom: 102px;
  }
}

#expandButton {
  font-size: 3rem;
  text-align: center;
}

@media (max-width: 1200px) {
  .barcode-input-wrap {
    width: 100%;
  }
}

.info-bar-back {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 0rem;
}

#expandButton { grid-area: 1 / 2 / 3 / 3; }
.back-button { grid-area: 1 / 3 / 3 / 4; }
.cargo-name { grid-area: 1 / 1 / 2 / 2; }
.pallet-places { grid-area: 2 / 1 / 3 / 2; }
.cargo-name-span { grid-area: 1 / 1 / 3 / 2; }
.cargo-finished-button, .cargo-finished { grid-area: 1 / 1 / 3 / 4; }

.cargo-finished {
  text-align: center;
}

.cargo-finished-checkmark {
  margin-left: 2rem;
}

.info-bar-back-no-top-padding {
  padding-top: 0px;
}
</style>
